// src/redux/slices/checkoutSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { fetchCheckoutSummary } from '../actions/checkoutAction';

const checkoutSlice = createSlice({
  name: 'checkout',
  initialState: {
    orderSummary: null,
    isLoading: false,
    error: null,
  },
  reducers: {
    clearCheckout: (state) => {
      state.orderSummary = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCheckoutSummary.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchCheckoutSummary.fulfilled, (state, action) => {
        state.isLoading = false;
        state.orderSummary = action.payload;
      })
      .addCase(fetchCheckoutSummary.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload.message;
      });
  },
});

export const { clearCheckout } = checkoutSlice.actions;
export default checkoutSlice.reducer;
